// Smart-quote / dash / NBSP cleanup. Source is usually a Google Docs or Word
// paste, where ' and " auto-convert to U+2018/U+2019 and U+201C/U+201D — these
// don't survive round-tripping through the marker, so we strip them at input.

// Length-preserving (every replacement is one char → one char). Use this when
// the result needs to align positionally with the original string, e.g. for
// findQuoteIndex.
export const normalizeForMatch = (s: string): string =>
  s.replace(/[‘’ʼ]/g, "'").replace(/[“”]/g, '"').replace(/[–—]/g, "-").replace(/ /g, " ");

// Aggressive paste-time cleanup. Length is not preserved (… → ...). Safe at
// the input boundary where we're committing canonicalised text into state.
export const normalizeOnPaste = (s: string): string => normalizeForMatch(s).replace(/…/g, "...");

// OUTPUT-side: house style is a spaced em-dash, but the coach model sometimes
// emits a tight one ("word—word"). Space it so feedback and marking prose read
// consistently. (Leaves an already-spaced or leading dash alone.)
export const spaceEmDashes = (text: string): string => text.replace(/(\S)—(\S)/g, "$1 — $2");
